export const TIPSTER_PREFERENCES_REQUEST = 'tipsterPreferencesRequest';
export const TIPSTER_PREFERENCES_FAILURE = 'tipsterPreferencesFailure';
export const TIPSTER_PREFERENCES_SUCCESS = 'tipsterPreferencesSuccess';
